var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_1896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 0.5H6.26562C2.95192 0.5 0.265625 3.18629 0.265625 6.5V14.5C0.265625 17.8137 2.95192 20.5 6.26562 20.5H14.2656C17.5793 20.5 20.2656 17.8137 20.2656 14.5V6.5C20.2656 3.18629 17.5793 0.5 14.2656 0.5Z",
    fill: "#00A3FF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3005 11.5139L10.6242 13.2845C10.6057 13.3338 10.6057 13.3873 10.6242 13.4366L11.7877 16.4831L13.1337 15.7412L11.5183 11.5139C11.4817 11.4166 11.3372 11.4166 11.3005 11.5139Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6569 8.53642C12.6203 8.43903 12.4759 8.43903 12.4391 8.53642L11.7628 10.307C11.7444 10.3562 11.7444 10.4098 11.7628 10.4591L13.6693 15.4467L15.0151 14.7048L12.6569 8.53642Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2659 4.65944C10.2991 4.65944 10.3324 4.66819 10.3621 4.6835L15.4947 7.51221C15.5543 7.54504 15.591 7.60632 15.591 7.67089V13.3272C15.591 13.3928 15.5543 13.453 15.4947 13.4858L10.3621 16.3146C10.3335 16.331 10.2991 16.3387 10.2659 16.3387C10.2326 16.3387 10.1994 16.3299 10.1695 16.3146L5.03704 13.4881C4.97743 13.4553 4.94074 13.3939 4.94074 13.3294V7.67198C4.94074 7.60632 4.97743 7.54614 5.03704 7.51331L10.1695 4.6846C10.1994 4.66819 10.2326 4.65944 10.2659 4.65944ZM10.2659 3.83325C10.0835 3.83325 9.90013 3.87812 9.73621 3.96894L4.60484 6.79655C4.27696 6.97711 4.0752 7.31087 4.0752 7.67198V13.3283C4.0752 13.6894 4.27696 14.0232 4.60484 14.2038L9.73738 17.0324C9.9013 17.1222 10.0835 17.1681 10.267 17.1681C10.4493 17.1681 10.6327 17.1233 10.7966 17.0324L15.9292 14.2038C16.257 14.0232 16.4588 13.6894 16.4588 13.3283V7.67198C16.4588 7.31087 16.257 6.97711 15.9292 6.79655L10.7955 3.96894C10.6315 3.87812 10.4481 3.83325 10.2659 3.83325Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83363 7.26709H8.53245C8.43501 7.26709 8.34787 7.32508 8.31463 7.41262L5.52539 14.7114L6.87129 15.4533L9.94255 7.41591C9.97122 7.34368 9.91505 7.26709 9.83363 7.26709Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.111 7.26709H10.8098C10.7124 7.26709 10.6252 7.32508 10.592 7.41262L7.40723 15.7467L8.75313 16.4886L12.2199 7.41591C12.2474 7.34368 12.1912 7.26709 12.111 7.26709Z",
    fill: "#00A3FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_1896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.265625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.d344475cf03016292036227a6234ca14.svg";
export { ForwardRef as ReactComponent };